import { AxiosRequestConfig } from 'axios';

export const patchConfig: AxiosRequestConfig = {
  transformRequest: [
    function changeContentType(data, headers) {
      const reqHeaders = headers;
      reqHeaders['Content-Type'] = 'application/merge-patch+json';
      return JSON.stringify(data);
    },
  ],
};

export const postImageConfig: AxiosRequestConfig = {
  transformRequest: [
    function changeContentType(data, headers) {
      const reqHeaders = headers;
      reqHeaders['Content-Type'] = 'multipart/form-data';
      return data;
    },
  ],
};
